export enum AlarmType {
  Critical = 'Critical',
  Warning = 'Warning',
  Info = 'Info',
}
